import { createSlice } from "@reduxjs/toolkit";
import { IPaidLeaveBalance } from "core/http/service/timeKeeping/resTypes";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
  data: IPaidLeaveBalance;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
  data: {
    approvedDay: 0,
    currentYear: 0,
    remainingDay: 0,
    residualPreviousYear: 0,
    seniority: 0,
    year: 0,
  },
};

const getPaidLeaveBalanceSlice = createSlice({
  name: "getPaidLeaveBalance",
  initialState,
  reducers: {
    getPaidLeaveBalanceStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    getPaidLeaveBalanceSuccess: (state, action) => {
      state.status = ReduxStateType.SUCCESS;
      state.data = action.payload;
    },
    getPaidLeaveBalanceFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
    resetPaidLeaveBalance: () => {
      return { ...initialState };
    },
  },
});

export const {
  getPaidLeaveBalanceStart,
  getPaidLeaveBalanceSuccess,
  getPaidLeaveBalanceFailed,
  resetPaidLeaveBalance,
} = getPaidLeaveBalanceSlice.actions;

export default getPaidLeaveBalanceSlice.reducer;
